import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export var DEFAULT_DATE_RANGE_PRESETS = {
  MONTH_TO_DATE: 'MONTH_TO_DATE',
  PREVIOUS_MONTH: 'PREVIOUS_MONTH',
  WEEK_TO_DATE: 'WEEK_TO_DATE',
  PREVIOUS_WEEK: 'PREVIOUS_WEEK',
  QUARTER_TO_DATE: 'QUARTER_TO_DATE',
  LAST_QUARTER: 'LAST_QUARTER',
  YEAR_TO_DATE: 'YEAR_TO_DATE',
  CUSTOM: 'CUSTOM',
  TODAY: 'TODAY',
  LAST_SEVEN_DAYS: 'LAST_SEVEN_DAYS',
  YESTERDAY: 'YESTERDAY'
};
var DATE_RANGE_PRESETS = _objectSpread(_objectSpread({}, DEFAULT_DATE_RANGE_PRESETS), {}, {
  LAST_ONE_MONTH: 'LAST_ONE_MONTH',
  LAST_THREE_MONTHS: 'LAST_THREE_MONTHS',
  LAST_SIX_MONTHS: 'LAST_SIX_MONTHS',
  LAST_ONE_YEAR: 'LAST_ONE_YEAR',
  LAST_EIGHTEEN_MONTHS: 'LAST_EIGHTEEN_MONTHS'
});
export default DATE_RANGE_PRESETS;